<template>
  <div class="contain">
    <div class="pg-pd12">
      <!-- <div class="record-num">共<span>{{ totalNum }}</span>条扣分记录</div> -->
      <div class="record-list">
        <div class="record-item line_bottom" v-for="(item, index) in recordList" :key="index">
          <div class="item-title">
            <div class="record-item-tit" @click="changeHide(index, item.show)">{{ item.monitorTypeCN }}</div>
             <div class="score" v-if="item.audited === 0 && item.submited === 1">未扣分</div>
             <div class="score" v-else>-{{ item.deduction / 100 }}分</div>
          </div>
          <div class="content">
            <div class="record-item-cont">
              <div class="line" v-if="item.deduction || item.audited == 1 || (item.monitorType== 'A1' && item.submited == 1 && item.audited == 0) "> 
                <div class="txt">
                  <span class="txt-tit">{{ pageType == "D" ? "事故名称" : "扣分原因" }}：</span>
                  <span class="txt-cont">{{ item.monitorType == "A1" ? getACategoryDectionReson(item) : item.deductionReason }}</span>
                </div>
              </div>
              <!-- <div class="line" v-if="item.respTime">
                <div class="txt">
                  <span class="txt-tit">响应时长：</span>
                  <span class="txt-cont">{{ item.respTime }}分钟</span>
                </div>
              </div>
              <div class="line" v-if="item.doneTime">
                <div class="txt">
                  <span class="txt-tit">处理时长：</span>
                  <span class="txt-cont">{{ item.doneTime }}</span>
                </div>
              </div>
              <div class="line" v-if="item.accidentTime">
                <div class="txt">
                  <span class="txt-tit">发生时间：</span>
                  <span class="txt-cont">{{ item.accidentTime }}</span>
                </div>
              </div>
              <div class="line" v-if="item.deductionTime">
                <div class="txt">
                  <span class="txt-tit">扣分时间：</span>
                  <span class="txt-cont">{{ item.deductionTime }}</span>
                </div>
              </div> -->
              <div class="line" @click="navTo(item.subType, item, item.subName)">
                <div class="to-detail">
                  <div>查看详情</div>
                  <img src="../../../../assets/image/tb-right.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 扣分记录列表
export default {
  name: "causeDeduction",
  props: {
    // 'id': String,
    noData: Object,
    recordList: Array,
    assessType:String,
  },
  data() {
    return {
      onHide: false,
      pageType: this.$route.query.pageType
    };
  },
  methods: {
    // navToAll(list) {
    //   sessionStorage.setItem("list", JSON.stringify(list));
    //   this.$router.push({
    //     path: "/appraise/deducList-all"
    //   });
    // },
    navTo(subType, row, subName) {
      this.$emit("navToDetail", subType, row, subName);
    },
    changeHide(index, key) {
      delete this.recordList[index].show;
      this.$set(this.recordList[index], "show", !key);
    },
    getACategoryDectionReson(item){
      if(item.monitorType== "A1" && item.submited == 1 && item.audited == 0){
        return "扣分情况待审核"
      }
      return item.deductionReason
    }
  },
  mounted() {},
  computed: {
    // 计算扣分记录总条数
    totalNum() {
      let total = 0;
      // for (let i = 0, length = this.recordList.length; i < length; i++) {
      //     total += parseInt(this.recordList[i].subList.length)
      // }
      return this.recordList.length;
    }
  },
  created() {
    // 二级列表大于5条时收起
    // for (let i = 0, length = this.recordList.length; i < length; i++) {
    //     if (this.recordList[i].subList.length > 5) {
    //         this.recordList[i].show = true
    //     } else {
    //         this.recordList[i].show = false
    //     }
    // }
  }
};
</script>

<style lang="less" scoped>
.contain {
  margin-bottom: 24px;
  margin-top: 24px;
  .pg-pd12 {
    padding-left: 12px;
    padding-right: 12px;

    .record-num {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 14px;
      span{
          color: #FF8C19;
          margin-left: 4px;
          margin-right: 4px;
      }
    }

    .record-list {
      background: #fff;
      margin-top: 12px;

      .record-item {
        padding-top: 16px;
        padding-bottom: 16px;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        .item-title {
          display: flex;
          justify-content: space-between;
        }
        .record-item-tit {
          position: relative;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          margin: 0 16px;
        }
        .score {
          height: 12px;
          font-size: 12px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(255, 77, 77, 1);
          line-height: 12px;
          margin-right: 16px;
        }
        .content {
          height: auto;
          .record-item-cont {
            line-height: 20px;
            transition: all 0.2s;
            padding: 12px 16px;

            .line {
              display: flex;
              justify-content: space-between;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              margin-bottom: 8px;
              .txt {
                display: flex;

                &-cont {
                  width: 192px;
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
              }

              .to-detail {
                position: relative;
                color: #36b374;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 4px;
                height: 12px;
                width: 80px;
                div {
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 50px;
                  line-height: 12px;
                }
                img {
                  position: absolute;
                  left: 50px;
                  top: 1px;
                  width: 12px;
                  height: 12px;
                }
              }
            }

            .line:last-child {
              margin-bottom: 0;
            }
          }
          .record-item-cont:last-child {
            padding-bottom: 0;
          }
          .ts-list {
            width: 100%;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(155, 155, 155, 1);
            position: relative;
            vertical-align: top;
            display: inline-block;
            text-align: center;
            .img {
              position: absolute;
              display: inline-block;
              width: 10px;
              height: 10px;
              top: 0;
              img {
                width: 100%;
              }
            }
          }
        }

        .hide {
          height: 0;
          margin-top: 0;
          overflow: hidden;
        }
      }
      .line_bottom:last-child::after {
        background: none;
      }
    }
  }
}
</style>
